import { useEffect, useRef } from 'react';
import { getIsPostPurchaseFlow, getUtmParam } from '../config/client';
import { useMsId } from '../stores/appStore';
import { sendPurchaseNotification } from '../api/endpoints';

const notifiedStorageKey = (metaSiteId: string) => `purchase-notified:${metaSiteId}`;

// Fires the partner purchase notification once per post-purchase visit. The utm is not checked
// against the webhook map here — the server alone decides (it must validate anyway, and a
// client-side copy of the list would drift).
export function usePurchaseNotification() {
  const metaSiteId = useMsId();
  const hasFiredRef = useRef(false);

  useEffect(() => {
    const utm = getUtmParam();

    if (hasFiredRef.current || !metaSiteId || !utm || !getIsPostPurchaseFlow()) {
      return;
    }

    try {
      if (localStorage.getItem(notifiedStorageKey(metaSiteId))) {
        return;
      }

      hasFiredRef.current = true;
      sendPurchaseNotification(utm)
        .then(() => localStorage.setItem(notifiedStorageKey(metaSiteId), 'true'))
        .catch(() => {});
    } catch {}
  }, [metaSiteId]);
}
